import styled from "styled-components";

export const DenmarkResponsibleGamingButtonBaseBox = styled.button<{imageUrl: string}>`
  background-image: url("${props => props.imageUrl}");
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  @media ${({theme}) => theme.mediaQuery.hover}{
    &:hover {
      opacity: 0.5;
    }
  }

  @media ${({theme}) => theme.mediaQuery.hoverNone}{
    &:active {
      opacity: 0.5;
    }
  }

`